let t = () => `
    <div class="toolbar-block-inline universal-search-tool"></div>
    <div class="toolbar-block-inline current-location-tool"></div>
    <div class="toolbar-block-inline feature-selection-tools"></div>
`;

export = t;